import type {ReactElement} from 'react';
import {Button, IconPlacement, ButtonSize, ButtonType} from '@Components/button';
import {exitWizardToOriginSurface, getWizardExitLabel} from '@Libraries/social-media-wizard-library';
import styles from './wizard-terminal-mobile-footer.module.scss';

export function WizardTerminalMobileFooter(): ReactElement {
  return (
    <footer className={styles.terminalMobileFooter}>
      <Button
        isFullWidth
        type={ButtonType.SECONDARY}
        size={ButtonSize.MEDIUM}
        icon="icon-arrow-left"
        iconPlacement={IconPlacement.LEFT}
        iconClassName="size-icon-20"
        text={getWizardExitLabel()}
        onClick={exitWizardToOriginSurface}
      />
    </footer>
  );
}
